export const CustomCode = {
  NONE: "",

  HELLO_TECHNO: "HELLO_TECHNO",
} as const;

export type CustomCode = (typeof CustomCode)[keyof typeof CustomCode];
